<template>
	<auth-layout :prev="{ name: 'login' }">
		<div class="col-lg-8 align-self-center">
			<b-alert v-model="success" variant="success" dismissible>
				{{ successMessage }}
			</b-alert>

			<h1>{{ $t('auth.forgot_password.title') }}</h1>

			<b-form @submit.prevent="request" novalidate>
				<div class="form-group">
					<text-input
						name="email"
						:label="$t('auth.forgot_password.email')"
						autocomplete="email"
						:autofocus="true"
						:error="error"
						v-model="email"
					/>
				</div>

				<b-button
					type="submit"
					variant="primary"
					block
					:disabled="processing"
				>
					<b-spinner small v-if="processing" />
					{{ $t('auth.forgot_password.submit_btn') }}
				</b-button>
			</b-form>
		</div>
	</auth-layout>
</template>

<script>
import AuthLayout from '../layouts/AuthLayout';
import TextInput from '../../components/forms/TextInput';
import { required, email as vEmail } from 'vuelidate/lib/validators';
import nprogress from 'nprogress';
import validate from '../../util/validate';
import ErrorModal from '../../mixins/ErrorModal';

export default {
	components: {
		AuthLayout,
		TextInput
	},

	inject: [ 'passwordRepository' ],

	mixins: [ ErrorModal ],

	data () {
		return {
			email: '',
			processing: false,
			submitted: false,
			serverError: '',
			success: false,
			successMessage: ''
		};
	},

	validations: {
		email: {
			required,
			vEmail
		}
	},

	computed: {
		error () {
			if (this.submitted) {
				if (!this.$v.email.required) {
					return this.$t('validation.required');
				}
				if (!this.$v.email.vEmail) {
					return this.$t('validation.email');
				}
				if (validate.getServerError(this.serverError, 'email') !== '') {
					return validate.getServerError(this.serverError, 'email');
				}
			}

			return '';
		},

		genericServerError () {
			return validate.getGenericError(this.serverError);
		}
	},

	methods: {
		async request () {
			this.processing = true;
			this.submitted = true;
			this.success = false;
			this.successMessage = '';

			if (this.$v.$invalid) {
				this.processing = false;
			}
			else {
				nprogress.start();

				try {
					this.successMessage = await this.passwordRepository.requestReset(this.email);
					this.success = true;
					this.submitted = false;
					this.email = '';
				}
				catch (e) {
					this.success = false;
					this.serverError = e;
				}

				this.processing = false;
				nprogress.done();
			}
		}
	},

	watch: {
		genericServerError () {
			if (this.genericServerError !== null) {
				this.showErrorModal(this.genericServerError, 'Error Sending Password Reset Email').then(() => {
					this.serverError = null;
				});
			}
		}
	}
};
</script>
